(() => { 
    const init = () => {
        let productSwatches = document.querySelectorAll('.color-swatch');
        let stickySwatches = document.querySelectorAll('.product-swatches .swatch');
        let addToCart = document.querySelector('.product-form__submit');
        let stickyAddToCart = document.querySelector('.product-add-to_cart');

        stickyAddToCart && stickyAddToCart.addEventListener('click', () => {
            addToCart.click()
        })

        Array.from(stickySwatches).forEach( (st) => {
            st.addEventListener( 'click', () => {
                Array.from(productSwatches).forEach( (sw) => {

                    if (sw.dataset.color == st.dataset.color) {
                      sw.children[0].click();
                      console.dir(sw);
                    }
                })
            })
        });

        Array.from(productSwatches).forEach( (swatch) => {
            if (swatch.classList.contains('checked')) {

                Array.from(stickySwatches).forEach( (sticky) => {
                    sticky.classList.remove('active');

                    if (sticky.dataset.color == swatch.dataset.color) {
                        sticky.classList.add('active');
                    }
                });
            }

            swatch.addEventListener( 'click', () => {

                Array.from(stickySwatches).forEach( (sticky) => {
                    sticky.classList.remove('active');

                    if (sticky.dataset.color == swatch.dataset.color) {
                        sticky.classList.add('active');
                    }
                })
            })
        })

        stickyAddToCart && document.addEventListener("scroll", modalScrollFunc);

        function modalScrollFunc() {
            const headerSelector = document.querySelector(".sticky-product__form");

            if (document.body.scrollTop > 1100 || document.documentElement.scrollTop > 1100) {
              headerSelector.classList.add('active')
            } else {
              headerSelector.classList.remove('active')
            }
        }
    }

    init();
})();